<template>
	<div>
		<div class="order_filter" @click.stop>
			<div
			    class="order_filter_cell"
				v-for="item in orderFilterList"
				:class="filterData.id === item.id ? 'type_act':'type_default'"
				@click.stop="typeClick(item)"
			>
				<span>{{item.name}}</span>
				<img
				  src="@/static/images/down.png"
					class="filter_cell_img"
					:class="{'trans_img': filterData.id === item.id && isPos}"
				/>
			</div>
		</div>

		<div
		    v-show="isPos"
			class="filter_list"
			@click.stop
		>
			<div
			    class="filter_list_cell"
				v-for="item in filterData.list"
				:class="{'drop_act': item.id === filterData.actId}"
				@click.stop="dropDownBind(item)"
			>
				{{item.title}}
			</div>
		</div>
		<div
		    v-show="isPos"
			class="shade"
			@click="isPos = false"
		></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				orderFilterList: [
					{
						id: 1,
						key: 'status',
						actId: 0,
						name: '付款状态',
						list: [
							{ id: 0, title: '全部付款' },
							{ id: 1, title: '未支付' },
							{ id: 2, title: '支付成功' },
							{ id: 3, title: '退款成功' },
						]
					},
					{
						id: 2,
						key: 'recharge_status',
						actId: 0,
						name: '订单状态',
						list: [
							{ id: 0, title: '全部充值' },
							{ id: 1, title: '未充值' },
							{ id: 2, title: '充值成功' },
							{ id: 3, title: '充值失败' },
							{ id: 5, title: '部分成功' }
						]
					},
					{
						id: 3,
						key: 'type',
						actId: 0,
						name: '订单类型',
						list: [
							// { id: 0, title: '全部类型' },
							// { id: 1, title: '常规订单' },
							// { id: 2, title: '组合订单' },
							// { id: 3, title: '充值余额' },
							// { id: 4, title: '批量充值' },
							// { id: 5, title: '生活缴费' }
						]
					},
				],
				actData: {
					list: [
						{ id: 0, title: '全部付款' },
						{ id: 1, title: '未支付' },
						{ id: 2, title: '支付成功' },
						{ id: 3, title: '退款成功' },
					]
				},
				typeAct: 1,
				isPos: false,
				filterData: {} //当前点击选择的筛选值
			}
		},
		computed: {
			orderType() {
				return JSON.parse(localStorage.getItem('orderType'))
			}
		},
		created() {
			this.$set(this.orderFilterList[2], 'list', this.orderType)
      // console.log('orderFilterList:', this.orderFilterList)
		},
		methods: {
			dropDownBind({id, title}) {
				this.$set(this.filterData, 'actId', id)
				this.$set(this.filterData, 'name', title)
				this.isPos = false
				this.emitData()
			},
			emitData() {
				const filterData = {}
				this.orderFilterList.forEach(item => {
					const { key, actId } = item
					filterData[key] = actId
				})
				this.$emit('change', filterData)
			},
			typeClick(item) {
				if (item.id === this.filterData.id && this.isPos) {
					this.isPos = false
					return;
				}
				this.filterData = item
				this.isPos = true
			}
		}
	}
</script>

<style lang="less" scoped>
	.filter_list {
		// width: 750rpx;
    width: 100%;
		position: fixed;
    top: 42.5px;
		left: 0;
		z-index: 9999;
		background-color: #fff;
		padding-left: 10px;
		transition: 2s;
		.filter_list_cell {
			height: 42px;
			line-height: 42px;
			border-bottom: 1px solid #f2f2f2;
			font-size: 13px;
		}
		.drop_act {
			color: #D23545;
		}
	}
	.shade {
		// width: 750rpx;
    width: 100%;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
	}
	.order_filter {
		// width: 750rpx;
    width: 100%;
		height: 42.5px;
		position: fixed;
		top: 0;
		left: 0;
    right: 0;
		z-index: 9999;
		padding: 0 12.5px;
		box-sizing: border-box;
		background-color: #fff;
		border-bottom: 1px solid #f2f2f2;
		display: flex;
		justify-content: space-between;
    max-width: 750px;
    margin: 0 auto;


		.type_act {
			font-size: 15.5px;
			color: #FB6363;
		}
		.type_default {
			font-size: 12px;
			color: #605F5D;
		}
		.order_filter_cell {
			display: flex;
			flex-direction: row;
			align-items: center;
			font-size: 13.5px;
			text {
				margin-right: 3px;
			}
			.filter_cell_img {
				width: 16px;
				max-height: 16px;
			}
			.trans_img {
				transform: rotate(180deg);
				margin-top: 4px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/components/historycard/order_filter.vue